import { useState, useEffect } from "react";

export function useInfiniteItems<T>(
  items: T[] | undefined,
  pageSize = 8,
) {
  const [visibleCount, setVisibleCount] = useState(pageSize);
  const total = items?.length ?? 0;

  // Reset to first page only when the total count changes (filter applied)
  // Using total (a number) as dep, NOT items (array ref) — avoids resetting on
  // every render when the parent recreates the array via .filter()
  useEffect(() => {
    setVisibleCount(pageSize);
  }, [total, pageSize]);

  const visibleItems = items?.slice(0, visibleCount) ?? [];
  const hasMore = total > visibleCount;

  // Plain closure — captures current visibleCount + total from this render
  const loadMore = () =>
    setVisibleCount(visibleCount + pageSize < total ? visibleCount + pageSize : total);

  return { visibleItems, hasMore, loadMore, total };
}
